import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import FormCard from 'src/components/ui/FormCard';
import CallsPicker from '../CallsPicker';
import { StoryCallsPickerPrimary } from './CallsPicker.stories';

export const CallsPickerForm = () => {
	return (
		<FormCard
			title="Звонки"
			fullHeight
			btnsNode={
				<>
					<Button variant="contained">Добавить к событию</Button>
					<Button sx={{ mr: 'auto' }} variant="outlined">
						Пометить «Бесполезным»
					</Button>
					<Typography sx={{ pr: 1 }}>Выбрано 2</Typography>
				</>
			}
		>
			<CallsPicker {...StoryCallsPickerPrimary.args} />
		</FormCard>
	);
};

export const StoryCallsPickerForm = {
	name: 'Drawer',
	render: CallsPickerForm,
};
